import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_CUSTOM_EVENTS_INTEGRATION } from "@lib/shared_constants";

export interface DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectResult {
  message: string;
}

export interface DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectProps {
  appGroupId: string;
}

export type DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectResultIntegrationNotFoundError =
  FetchUserEncodedError<SHARED_CONSTANTS_CUSTOM_EVENTS_INTEGRATION["INTEGRATION_NOT_FOUND"]>;

export type DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectResultErrors =
  DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectResultIntegrationNotFoundError;

export const isDeleteAlloysAdjustCustomEventsAppGroupIdDisconnectResultError = (
  error: FetchRequestError
): error is DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectResultErrors => {
  return error instanceof FetchUserEncodedError;
};
